module.exports = __webpack_public_path__ + "static/media/T6-01.b9ee85f7.svg";